import React from "react";
import { Slider } from "primereact/slider";
import { Accordion, AccordionTab } from "primereact/accordion";
import Filter from "../components/Filter";

function FilterComponent({
    insertType,
    productType,
    materialType,
    collectionType,
    priceMinMax,
    priceFilter,
    setPriceFilter,
    debouncedFilter,
    filterProducts,
    materialFilter,
    setMaterialFilter,
    insertTypeFilter,
    setInsertTypeFilter,
    setProductTypeFilter,
    productTypeFilter,
    collectionTypeFilter,
    setCollectionTypeFilter,
}) {
    return (
        <div className="">
            <div className="p-6">
                <div className="mb-2 price-title">Ціна</div>
                <Slider
                    value={priceFilter}
                    onChange={(e) => {
                        setPriceFilter(e.value);
                        debouncedFilter(
                            e.value,
                            materialFilter,
                            productTypeFilter,
                            insertTypeFilter,
                            collectionTypeFilter
                        );
                    }}
                    min={priceMinMax[0]}
                    max={priceMinMax[1]}
                    range
                />
            </div>

            <Accordion>
                <AccordionTab header="Вставка">
                    <div className="flex flex-col gap-4">
                        {insertType.map((insert) => (
                            <Filter
                                title={insert}
                                activeItems={insertTypeFilter}
                                key={insert}
                                onChange={(value) => {
                                    setInsertTypeFilter(value);
                                    filterProducts(
                                        priceFilter,
                                        materialFilter,
                                        productTypeFilter,
                                        value,
                                        collectionTypeFilter
                                    );
                                }}
                            />
                        ))}
                    </div>
                </AccordionTab>
                <AccordionTab header="Тип виробу">
                    <div className="flex flex-col gap-4">
                        {productType.map((product) => (
                            <Filter
                                title={product}
                                activeItems={productTypeFilter}
                                key={product}
                                onChange={(value) => {
                                    setProductTypeFilter(value);
                                    filterProducts(
                                        priceFilter,
                                        materialFilter,
                                        value,
                                        insertTypeFilter,
                                        collectionTypeFilter
                                    );
                                }}
                            />
                        ))}
                    </div>
                </AccordionTab>
                <AccordionTab header="Матеріал">
                    <div className="flex flex-col gap-4">
                        {materialType.map((material) => (
                            <Filter
                                title={material}
                                activeItems={materialFilter}
                                onChange={(value) => {
                                    setMaterialFilter(value);
                                    filterProducts(
                                        priceFilter,
                                        value,
                                        productTypeFilter,
                                        insertTypeFilter,
                                        collectionTypeFilter
                                    );
                                }}
                                key={material}
                            />
                        ))}
                    </div>
                </AccordionTab>
                <AccordionTab header="Колекція">
                    <div className="flex flex-col gap-4">
                        {collectionType.map((collection) => (
                            <Filter
                                title={collection}
                                activeItems={collectionTypeFilter}
                                onChange={(value) => {
                                    setCollectionTypeFilter(value);
                                    filterProducts(
                                        priceFilter,
                                        materialFilter,
                                        productTypeFilter,
                                        insertTypeFilter,
                                        value
                                    );
                                }}
                                key={collection}
                                isCapitalize
                            />
                        ))}
                    </div>
                </AccordionTab>
            </Accordion>
        </div>
    );
}

export default FilterComponent;
